import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetChatSingle = {
  getChatSingle: { data: null, loading: false, error: null },
};

export const getChatSingle = createAsyncThunk('user/getChatSingle', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/chats/${data}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetChatSingle = {
  [getChatSingle.pending]: (state) => {
    // state.getChatSingle.data = null;
    state.getChatSingle.loading = true;
    state.getChatSingle.error = null;
  },
  [getChatSingle.fulfilled]: (state, action) => {
    state.getChatSingle.loading = false;
    state.getChatSingle.data = action.payload;
    state.getChatSingle.error = null;
  },
  [getChatSingle.rejected]: (state, action) => {
    state.getChatSingle.loading = false;
    state.getChatSingle.error = action.payload;
  },
};
